<ul class="steps" [class.disabled]="stepper.state === StepperState.NOT_STARTED">
  @for (step of stepper.steps; track step) {
    <li [class.current]="step.state === StepperState.IN_PROGRESS">
      <span>{{ step.title }}</span>
    </li>
  }
</ul>
